module.exports = {
      id: "web-story-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#web-story",
      toString: function () {
        return this.url;
      }
    }